var skin = "/skins/buy2beeuk";
var messageBoxDuration = 2500;